/**
 
 * Component : provides the skeleton rows of the table that can be used to show loading for a table
 * @rows : Props which defines the number of rows we want to show for table
 * @cols : Props which defined the number of cols we want to show for table
 
 */

import { Skeleton } from '@mui/material'
import React from 'react'

const SkeletonRows = ({rows, cols}) => {

    const dummyRows = new Array(rows).fill(null);
    const dummyCols = new Array(cols).fill(null)

    return (
        <>
            {
                dummyRows.map((row, index) => {
                    return <tr key={index}>
                    {
                        dummyCols.map((col, index) => {
                            return <td key={index}>
                                <Skeleton variant='text' height={33}/>
                            </td>
                        })
                    }
                    
                    </tr>
                })
            }
        </>
    )
}

export default SkeletonRows